import { 
    GET_COURSES_LOADING, GET_COURSES_SUCCESS, GET_COURSES_ERROR,
    GET_MIN_COURSES_LOADING, GET_MIN_COURSES_SUCCESS, GET_MIN_COURSES_ERROR
} from "../../../constant/actionTypes";

const coursesReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_COURSES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }

        case GET_COURSES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        
        case GET_COURSES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }

        case GET_MIN_COURSES_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        
        case GET_MIN_COURSES_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case GET_MIN_COURSES_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default coursesReducer;